// @ts-expect-error: This variable is coming from webpack define.
// TODO: Needs more checking, this should be returning shorthand COMMITHASH, but returns strange value.
(window as any).VERSION = VERSION;
// @ts-expect-error: This variable is coming from webpack define.
(window as any).COMMITHASH = COMMITHASH;
// @ts-expect-error: This variable is coming from webpack define.
(window as any).BRANCH = BRANCH;
